import { NgModule } from "@angular/core";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { TableModule } from "primeng/table";
import { DatePipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import {
    MedBubbleModule,
    MedCheckboxModule, MedDatepickerModule,
    MedDirectiveSharedModule, MedInputModule, MedMultiSelectModule,
    MedPaginationModule,
    MedRadioGroupModule,
} from "@mk/med-ui";
import { TooltipModule } from "primeng/tooltip";
import { ProgressBarModule } from "primeng/progressbar";
import {
    MedIconArrowDownModule, MedIconCloseModule, MedIconHistoryModule,
    MedIconPlusModule, MedIconRefreshModule,
    MedIconTriangleDownModule,
    MedIconTriangleUpModule,
} from "@mk/med-icons";
import { LoaderModule } from "@app/components/loader/loader.module";
import { DistributionsDozComponent } from "@app/components/distributions/doz/dustributions.doz.component";
import { ScrollPanelModule } from "primeng/scrollpanel";
import {SidebarModule} from "primeng/sidebar";
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    DistributionsDozComponent,
  ],
    imports: [
        PageTitleModule,
        TableModule,
        NgForOf,
        NgIf,
        NgStyle,
        NgClass,
        DatePipe,
        MedCheckboxModule,
        MedPaginationModule,
        MedRadioGroupModule,
        TooltipModule,
        ProgressBarModule,
        MedBubbleModule,
        MedIconPlusModule,
        MedIconArrowDownModule,
        MedIconTriangleDownModule,
        MedIconTriangleUpModule,
        MedDirectiveSharedModule,
        LoaderModule,
        ScrollPanelModule,
        MedIconCloseModule,
        MedIconHistoryModule,
        MedInputModule,
        SidebarModule,
        FormsModule,
        MedIconRefreshModule,
        MedDatepickerModule,
        MedMultiSelectModule,

    ],
  exports: [],
})
export class DistributionsDozModule {}
